export const modalActionTypes = Object.freeze({
  CREATE: "CREATE",
  EDIT: "EDIT"
});
